import React from "react";
import "./NavigationBar.scss";
import {withTranslation} from "react-i18next";
                                            
import SearchIcon from "./icons/SearchIcon";
import ShoppingBag from "./icons/ShoppingBag";

                           
                          
                 
                          
  

const NavigationBar = (props                    ) => {
    const setFocus = selector => {
        const input = document.querySelector(selector);
        input.focus();
        input.select();
    };

    const toggleCard = () => {
        const node = document.getElementById("sl-content-root");
        if (node) {
            node.classList.toggle("card-on");
            node.classList.remove("menu-on");
        }
    };
    const toggleSearch = e => {
        e.preventDefault();
        const node = document.getElementById("sl-content-root");
        if (node) {
            node.classList.toggle("search-on");

            const searchContainer = document.querySelector(".search-on");

            if (searchContainer) {
                setFocus(".searchTerm");
            }
        }
    };

    const toggleFilter = () => {
        const node = document.getElementById("sl-content-root");
        if (node) {
            node.classList.toggle("menu-on");
            node.classList.remove("card-on");
        }
    };

    return <nav>
	<span>
		<button className="filter toggle-menu" type={"button"} data-testid={"filter"}
                onClick={() => toggleFilter()}>
			<span className={"filter-text"}>{props.t("navigation.filtern")}</span>
			<span className={"filter-close-text"}
                  data-testid={"closeFilter"}>{props.t("navigation.closeFilter")}</span>
		</button>
	</span>
	<span>
		{
			<button aria-label={props.t("navigation.toggleSearch")} className="glass toggle-search"
                    data-testid={"openSearch"}
                    onClick={e => toggleSearch(e)}>
				<SearchIcon fill={"black"}/>
			</button>
        }
		{!props.cartDisabled &&
		<button className="cart toggle-card" data-testid={"cartIcon"}
                        type={"button"} onClick={() => toggleCard()}>
			<ShoppingBag fill={"#000000"} className={"cart"}/>
			{!!props.cartItemCount &&
			<span className="bubble" data-testid={"cartCount"}>{props.cartItemCount}</span>}
		</button>
            }
	</span>
    </nav>;
};

export default withTranslation()(NavigationBar);
